<div [formGroup]="form" class="signer-item-form gap-3">
  <app-signer-custom-input
    #signerInput
    [ctrl]="form.get('name')"
    [placeholder]="(role ? role + ' ' : '') + 'Name'"
    bindLabel="name"
    i18n-matTooltip
    matTooltip="Signer Name"
    [isGuestEnabled]="isGuestEnabled"
    [isUserEnabled]="isUserEnabled"
    [role]="role"
    class="flex-1"
  ></app-signer-custom-input>
  <app-signer-custom-input
    [ctrl]="form.get('email')"
    [placeholder]="(role ? role + ' ' : '') + 'Email'"
    i18n-matTooltip
    matTooltip="Search for the email address of a guest or user. You can also enter an email address of a person not in your address book or user list."
    bindLabel="email"
    [role]="role"
    [searchable]="false"
    class="flex-1"
  ></app-signer-custom-input>

  <div class="contact-addition-wrapper">
    <div class="toggle-btns-wrapper text-xxl">
      <span
        class="toggle-btn"
        i18n-matTooltip
        matTooltip="Mark National ID as Required"
        [class.active]="isIdPhotoRequired"
        (click)="toggleIdPhoto()"
      >
        <i class="cs-icon" [ngClass]="isIdPhotoRequired ? 'cs-icon-id-card-solid' : 'cs-icon-id-card'"></i>
      </span>
      <span
        class="toggle-btn selfie-icon"
        i18n-matTooltip
        matTooltip="Mark Selfie as Required"
        [class.active]="isSelfiePhotoRequired"
        (click)="toggleSelfiePhoto()"
      >
        <i class="cs-icon" [ngClass]="isSelfiePhotoRequired ? 'cs-icon-selfie-solid' : 'cs-icon-selfie'"></i>
      </span>
      <span
        *ngIf="form.get('email').value && form.get('email').value !== form.get('data').value?.primaryEmail"
        class="toggle-btn"
        i18n-matTooltip
        matTooltip="Save to address book"
        [class.active]="shouldSaveContact"
        (click)="toggleSaveContact()"
      >
        <i class="fa-save" [ngClass]="shouldSaveContact ? 'fas' : 'fal'"></i>
      </span>
    </div>
    <div class="toggle-btns-description" [class.active]="isIdPhotoRequired || isSelfiePhotoRequired">
      {{ getPhotosRequirementDescription() }}
    </div>
  </div>

  <a
    *ngIf="removable"
    matTooltip="Click here to remove this signer"
    class="btn btn-sm btn-light-danger"
    (click)="onRemove()"
  >
    <i class="cs-icon cs-icon-trash text-xl"></i>
  </a>
</div>
